import * as GroupRetrievalService from './GroupRetrievalService';
import * as GroupSaveService from './GroupSaveService';
import * as PartnerRetrievalService from './PartnerRetrievalService';
import * as PartnerSaveService from './PartnerSaveService';
import * as RoleRetrivalService from './RoleRetrivalService';
import * as RoleSaveService from './RoleSaveService';
import * as UserManagementApiClientService from './UserManagementApiClientService';
import * as UserRetrievalService from './UserRetrievalService';
import * as UserSaveService from './UserSaveService';

export {  GroupRetrievalService, GroupSaveService, PartnerRetrievalService, PartnerSaveService, RoleRetrivalService, RoleSaveService, UserManagementApiClientService, UserRetrievalService, UserSaveService };